<template>
    <div v-if=companydb_id>
        <InvoiceableEditorComponent 
            :companydb_id="companydb_id"
            :invoiceable_type="'budget'"
            :invoiceable_id="budget_id"
            :next_number="next_number"
            :default_sequence_id="default_sequence_id"
            :key="$route.fullPath"
            :invoiceable_id_list="invoiceable_id_list"/>
    </div>
</template>

<script>
import InvoiceableEditorComponent from '@/modules/facturae/infra/InvoiceableEditorComponent.vue';
export default {
    name: 'budget-editor',
    components: {
        InvoiceableEditorComponent
    },
    
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
        budget_id: {
            type: [Number, String],
            required: false,
            default: null
        },
        next_number: {
            type: [String],
            required: false,
            default: null
        },
        default_sequence_id: {
            type: [Number],
            required: false,
            default: null
        },
        invoiceable_id_list: {
            type: [Array],
            required: false,
            default: null
        },
    },
    
    data() {
        return {
        }
    },
}
</script>